import { Margin } from '@mui/icons-material';
import * as React from 'react';

// <i class="fa-duotone fa-comments-dollar" style="--fa-primary-color: #1f5127; --fa-secondary-color: #09f12f; --fa-secondary-opacity: 1;"></i>

export const getBs4Icon = (props) => {
  if (!props.iconCls) return props.instead || null;
  return <Bs4Icon {...props}/>
}

export const Bs4Icon = (props) => {
  const icon = React.useMemo(() => {
    // const iconStyle = (props.iconStyle || '').replace('backgroundColor', 'background-color');
    return `<i class="${props.iconCls}" style="${props.iconStyle}"/>`;
    // return `<i class="${props.iconCls}" style="${iconStyle}"/>`;
    // return `<i class="${props.bs4Class}" style="${"color: #ff8800"}"/>`;
    // return `<i class="${props.bs4Class}" style="${"--fa-primary-color: #1f5127; --fa-secondary-color: #09f12f; --fa-secondary-opacity: 1;"}"/>`;
    // return '<i class="fa-duotone fa-comments-dollar" style="--fa-primary-color: #1f5127; --fa-secondary-color: #09f12f; --fa-secondary-opacity: 1;"></i>';
  }, [props.iconCls, props.iconStyle]);

  if (!props.iconCls) return props.instead || null;

  return (
    <span dangerouslySetInnerHTML={{__html: icon}}/>
  )
}
export default Bs4Icon;